@if (currentResourceRequest) {
	<mat-form-field appearance="fill" class="form-field-mdc-legacy form-field-mdc-legacy-white text-box lessPadding">
		<input
			matInput
			#resourceRequestInput
			[matAutocomplete]="resourceRequestAuto.matAutocomplete"
			[value]="getCurrentResourceRequestText()"
			(blur)="onLeaveText()"
		/>
		@if (resourceRequestInput.value.length > 0) {
			<button mat-icon-button matSuffix aria-label="Clear" (click)="onClear()">
				<mat-icon>close</mat-icon>
			</button>
		}
		<resource-request-autocomplete
			#resourceRequestAuto
			(elementSelected)="onItemChange($event)"
			[inputElement]="resourceRequestInput"
		>
		</resource-request-autocomplete>
	</mat-form-field>
}
